import PatientCase from './PatientCase';

export default PatientCase;
